/**
 * Copyright (c) oct16.
 * https://github.com/oct16
 *
 * This source code is licensed under the GPL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export enum PlayerEventTypes {
    INIT = 'init',
    PLAY = 'play',
    PAUSE = 'pause',
    STOP = 'stop',
    SPEED = 'speed',
    RESIZE = 'resize',
    PROGRESS = 'progress',
    JUMP = 'jump'
}
